export default __webpack_public_path__ + "static/download-now-cd2525acad7550fb2da702de06552b5b.png";